export class Product {
  id: string;
  count: number;
  code: number= 0;
  name: string= "";
  packaging: string= "";
  category: string="";
}